import { AiOutlineMessage } from "react-icons/ai";
import { handleClickHelp, purple } from "./utils";
import { WiSmallCraftAdvisory } from "react-icons/wi";

const CustomIcon = ({ setOpen, setSteps, steps, type }) => {
    const renderIcon = () => {
        if (type === "test") {
            return <WiSmallCraftAdvisory />
        }
        return <AiOutlineMessage className="position clickable" onClick={() =>  handleClickHelp({ setOpen, setSteps, steps})} title="Aide à l'utilisation" color={purple} />
    }

   
    return (
        <>
        {renderIcon()}
        </>
    );
}

export default CustomIcon;